import { render, staticRenderFns } from "./ThatsIsTab.vue?vue&type=template&id=d52d6d90&"
import script from "./ThatsIsTab.vue?vue&type=script&lang=js&"
export * from "./ThatsIsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports